import { render, staticRenderFns } from "./UserProduct.vue?vue&type=template&id=5d102670&"
import script from "./UserProduct.vue?vue&type=script&lang=js&"
export * from "./UserProduct.vue?vue&type=script&lang=js&"
import style0 from "./UserProduct.vue?vue&type=style&index=0&id=5d102670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports